module.exports = __webpack_public_path__ + "img/guide16.e19771f2.jpg";